import { render, staticRenderFns } from "./InquireApp.vue?vue&type=template&id=876dcdda&scoped=true&"
import script from "./InquireApp.vue?vue&type=script&lang=js&"
export * from "./InquireApp.vue?vue&type=script&lang=js&"
import style0 from "./InquireApp.vue?vue&type=style&index=0&id=876dcdda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876dcdda",
  null
  
)

export default component.exports